import React from "react";
import CareManagerDashboard from "./careManagerDashboard";
import PatientDashboards from "../dashboards/patient/Dashboard";
import InventoryDashboardPage from "../inventory/InventoryDashboardPage";

import useRoles from "../../hooks/useRoles";
import { Navigate } from "react-router-dom";

const Dashboards = () => {
  const { roles } = useRoles();

  if (roles.includes("TOCA Admin")) {
    return <CareManagerDashboard />;
  }
  // if (
  //   roles.includes("TOCA Inventory Manager") &&
  //   !roles.includes("Super User")
  // ) {
  //   return <Navigate to="/inventory/dashboard" />;
  // }
  if (roles.includes("Super User")) {
    return <CareManagerDashboard />;
  }
  if (roles.includes("Account Admin")) {
    return <CareManagerDashboard />;
  }
  if (roles.includes("Case Manager")) {
    return <CareManagerDashboard />;
  }
  if (roles.includes("Patient")) {
    return <PatientDashboards />;
  }
  return <h1>UnAuthorized access</h1>;
};

export default Dashboards;
